<table>
    <tr>
        <td class="fixed">
            <sector-detail [price]="price"
                           [costOrRetail]="costOrRetail"
                           [booking]="booking"
                           [differences]="differences"
                           [tarificationPrice]="tarificationPrice">

            </sector-detail>
        </td>
        <td class="fixed">
            <div class="tarification-header__resume-column">
                <div class="tarification-info">
                    <ng-container *ngIf="travellerSummary || travellersDifference;else empty;">
                        <span class="tarification-label">{{ wording.traveller }}</span>
                        <span class="tarification-value">
                                    <display-difference *ngIf="travellersDifference; else noTravellerDifference"
                                                        [difference]="travellersDifference" [showOtherValue]="false">
                                    </display-difference>
                                    <ng-template #noTravellerDifference>{{ travellerSummary }}</ng-template>
                                </span>
                    </ng-container>
                </div>


                <div class="tarification-info">
                    <ng-container *ngIf="vendor || vendorDifference;else empty;">
                        <span class="tarification-label">{{ wording.vendor }}</span>
                        <span class="tarification-value">
                                    <display-difference *ngIf="vendorDifference; else noVendorDifference"
                                                        [difference]="vendorDifference">
                                    </display-difference>
                                    <ng-template #noVendorDifference>{{ vendor }}</ng-template>
                                </span>
                    </ng-container>
                </div>

                <div class="tarification-info">
                    <ng-container *ngIf="tarification || tarificationDifference;else empty;">
                        <span class="tarification-label">{{ wording.tarification }}</span>
                        <span class="tarification-value">
                                     <display-difference *ngIf="tarificationDifference; else noTarificationDifference"
                                                         [difference]="tarificationDifference" [showOtherValue]="false">
                                    </display-difference>
                                    <ng-template #noTarificationDifference>{{ tarification }}</ng-template>
                                </span>
                    </ng-container>
                </div>

                <div class="tarification-info">
                    <ng-container *ngIf="validity || validityDifference;else empty;">
                        <span class="tarification-label">{{ wording.validity }}</span>
                        <span class="tarification-value">
                                    <display-difference *ngIf="validityDifference; else noValidityDifference"
                                                        [difference]="validityDifference" [dateFormat]="dateFormat"
                                                        [showDaysDifference]="true">
                                    </display-difference>
                                    <ng-template #noValidityDifference>{{ validity | date:dateFormat }}</ng-template>
                                </span>
                    </ng-container>
                </div>

                <div class="tarification-info">
                    <ng-container *ngIf="whenToIssued;else empty;">
                        <span class="tarification-label">{{ whenToIssuedTitle }}</span>
                        <span class="tarification-value">{{ whenToIssued | date:dateFormat }}</span>
                    </ng-container>
                </div>

                <div class="tarification-info">
                    <ng-container *ngIf="hostCode;else empty;">
                        <span class="tarification-label">{{ wording.source }}</span>
                        <span class="tarification-value">{{ hostCode }}</span>
                    </ng-container>
                </div>

                <div class="tarification-info">
                    <ng-container *ngIf="luggageCode || luggageDifference;else empty;">
                        <span class="tarification-label">{{ wording.baggage }}</span>
                        <span class="tarification-value">
                            <display-difference *ngIf="luggageDifference; else noLuggageDifference"
                                                [difference]="luggageDifference" [showOtherValue]="false">
                            </display-difference>
                            <ng-template
                                #noLuggageDifference>{{ luggageCode === luggageInHold ? wording.included : luggageCode }}</ng-template>
                        </span>
                    </ng-container>
                </div>

                <div class="tarification-info" *ngIf="savingsPerAdult?.length; else empty;">
                    <span class="tarification-label">{{ wording.savingPerAdult }}</span>
                    <span class="tarification-value savingPerAdult">
                        <span *ngFor="let savingPerAdult of savingsPerAdult;"
                              [innerHTML]="savingPerAdult.value | price:savingPerAdult.currencyCode"></span>
                    </span>
                </div>
                <ng-template #empty>
                    <span class="tarification-label">&nbsp;</span>
                </ng-template>
            </div>
        </td>
    </tr>
</table>
<div class="optimisation-timestamp">
    <span *ngIf="whenLastUpdated; else empty">{{ whenLastUpdated | date:'EEEE d MMMM y, HH:mm:ss'|titlecase }}</span>
    <ng-template #empty><span>&nbsp;</span></ng-template>
</div>
